import React from 'react';
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

const TitleBox = styled(Typography)(({ theme }) => ({
    fontSize: '3rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '12px',
    margin: '0 10px',
    '& span': {
        color: '#1DAFA1',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2.5rem',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '1.7rem',
    },
}))

const Title = ({ children, variant }) => {
    return (
        <TitleBox variant={variant}>
            {children}
        </TitleBox>
    );
};

export default Title;